<script>
    export let width = "full";
    export let padding = "";
    export let boxShadow;
    $: widthClass = width === "full" ? "full-width" : "";
    $: paddingClass = padding === "none" ? "no-padding" : "";
    $: boxShadow = boxShadow ? "box-shadow": "";
</script>

<!--src/components/FlatCard.svelte-->
<div class="flat-card {widthClass} {paddingClass} {boxShadow}">
    <slot />
</div>

<style>
    div.flat-card {
        padding: 24px;
        border-radius: 6px;
        background-color: var(--backgroundColorLightest);
    }
    div.flat-card.full-width {
        width: 100%;
    }
    div.flat-card.no-padding {
        padding: 0px;
    }
    div.box-shadow {
        box-shadow: 0px 5px 20px rgba(0, 0, 0, 0.15);
    }
</style>
